import { render, staticRenderFns } from "./LebotBalao.vue?vue&type=template&id=1910460c&scoped=true"
import script from "./LebotBalao.vue?vue&type=script&lang=js"
export * from "./LebotBalao.vue?vue&type=script&lang=js"
import style0 from "./LebotBalao.vue?vue&type=style&index=0&id=1910460c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1910460c",
  null
  
)

export default component.exports